import { Column } from 'devextreme-react/data-grid';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { formatMessage } from 'devextreme/localization';
import { Button } from 'devextreme-react/button';
import { LoadIndicator } from 'devextreme-react';
import styles from './correctionReadyProductsTable.module.scss';
import columnDataGrid from './columnDataGrid';
import DataGridMVP from '../../DataGridMVP';
import HeaderButtonMVP from '../../HeaderButtonMVP';
import PopupMVP from '../../PopupMVP';
import InputModalReadyProducts from '../InputModalReadyProducts';
import AddSemiForCorrection from '../AddSemiForCorrection';
import { sleep } from '../../../utils/functions';

// eslint-disable-next-line no-extend-native,func-names
Array.prototype.sum = function (prop) {
  let total = 0;
  // eslint-disable-next-line no-plusplus
  for (let i = 0, len = this.length; i < len; i++) {
    total += this[i][prop];
  }
  return total;
};

const CorrectionReadyProductsTable = ({
  correctionReadyProductsReducer,
  tabsReducer: { tabSelect },
  clearCorrectionSemiProductsClear,
  deleteReadyProducts,
  deleteReadyProductsMultiple,
  getReadyProducts,
  getSemiProductByReady,
  inputReadyProductReducer,
  inputReadyProducts,
  plantId,
  sendForMounting,
  updateReadyProducts,
  useFactWeight
}) => {
  const [headButtVisible, setHeadButtVisible] = useState({ display: 'none' });
  const [deleteConfirmationVisible, setDeleteConfirmationVisible] = useState(
    false
  );
  const [visibleModalInput, setVisibleModalInput] = useState(false);
  const [dataSource, setDataSource] = useState({ selectList: [] });
  const [correctionSemiModalVisible, setCorrectionSemiModalVisible] = useState(
    false
  );
  const [onModalSaveClick, setOnModalSaveClick] = useState(() => () => {});
  const [validateInstance, setValidateInstance] = useState(null);

  const [selectedKey, setSelectedKey] = useState(-1);
  const isInputReadyProduct = useRef(0);

  useEffect(() => {
    if (tabSelect === 8) {
      getReadyProducts({ plantId });
      setTimeout(() => {
        try {
          isInputReadyProduct.current = 0;
        } catch (e) {
          console.debug('ERROR isInputReadyProduct.current', e);
        }
      }, 1500);
    }
  }, [
    getReadyProducts,
    plantId,
    visibleModalInput,
    inputReadyProductReducer.okUpdateRequest,
    tabSelect
  ]);

  const closeHeaderButton = useCallback(() => {
    setHeadButtVisible({ display: 'none' });
    clearCorrectionSemiProductsClear();
  }, [clearCorrectionSemiProductsClear]);

  const updateSemiProduct = useCallback((selectedRowsData) => {
    let selectList = null;
    if (selectedRowsData && selectedRowsData.length) {
      selectList = selectedRowsData;
    } else if (dataSource.selectList && dataSource.selectList.length) {
      selectList = dataSource.selectList;
    }
    if (selectList) {
      getSemiProductByReady(selectList.map((el) => el.pieceNumId));
      inputReadyProducts(selectList[0].operationNumId);
    }
  }, [dataSource.selectList, getSemiProductByReady, inputReadyProducts]);

  const onSelectionChanged = useCallback(({ selectedRowsData, currentSelectedRowKeys }) => {
    if (selectedRowsData.length) {
      let showButtons = true;
      setSelectedKey(currentSelectedRowKeys);
      selectedRowsData.forEach((item) => {
        if (item.psStatusNumId > 1) {
          showButtons = false;
        }
      });
      if (showButtons) {
        setHeadButtVisible({ display: 'flex', maxWidth: '40%' });
      } else {
        setHeadButtVisible({ display: 'none' });
      }
      setDataSource((item) => ({
        ...item,
        selectList: selectedRowsData
      }));
      updateSemiProduct(selectedRowsData);
    } else {
      setHeadButtVisible({ display: 'none' });
    }
  }, [updateSemiProduct]);

  useEffect(() => {
    if (dataSource.selectList && dataSource.selectList.length && selectedKey === -1) {
      getSemiProductByReady(dataSource.selectList.map((el) => el.pieceNumId));
      inputReadyProducts(dataSource.selectList[0].operationNumId);
    }
  }, [
    dataSource,
    dataSource.selectList,
    getSemiProductByReady,
    inputReadyProducts,
    plantId,
    selectedKey
  ]);

  const onClickInputData = useCallback(async () => {
    await inputReadyProducts(dataSource.selectList[0].operationNumId);
    setVisibleModalInput(true);
  }, [dataSource.selectList, inputReadyProducts]);

  const onClickToMount = useCallback(() => {
    if (correctionReadyProductsReducer.readyProducts && correctionReadyProductsReducer.readyProducts
      .filter((item) => item.operationNumId !== selectedKey).length) {
      sendForMounting({
        pieceNumId: correctionReadyProductsReducer.readyProducts
          .filter((item) => item.operationNumId !== selectedKey)[0].pieceNumId,
        operationType: correctionReadyProductsReducer.readyProducts
          .filter((item) => item.operationNumId !== selectedKey)[0].mountingDate === null
          ? 1 : 0,
        plantId
      });
    }
  }, [correctionReadyProductsReducer.readyProducts, plantId, selectedKey, sendForMounting]);

  const onModalHiding = useCallback(() => {
    setVisibleModalInput(false);
    setDeleteConfirmationVisible(false);
  }, []);

  function saveOperation() {
    if (validateInstance) {
      new Promise((res) => {
        if (validateInstance.validate().status !== 'pending') {
          res(validateInstance.validate());
        }
      }).then((result) => {
        if (result.isValid && isInputReadyProduct.current === 0) {
          isInputReadyProduct.current += 1;
          updateReadyProducts({
            inputPieces: inputReadyProductReducer.inputPieces,
            length: inputReadyProductReducer.length,
            mark: inputReadyProductReducer.mark,
            normativeDoc: inputReadyProductReducer.normativeDoc,
            operationNumId: inputReadyProductReducer.operationNumId,
            operationType: inputReadyProductReducer.operationType,
            pieceId: inputReadyProductReducer.pieceId,
            pieceNumId: inputReadyProductReducer.pieceNumId,
            profileSize: inputReadyProductReducer.profileSize,
            qcDate: inputReadyProductReducer.qcDate,
            qcId: inputReadyProductReducer.qcId,
            qty: inputReadyProductReducer.qty,
            thickness: inputReadyProductReducer.thickness,
            weight: useFactWeight
              ? inputReadyProductReducer.weightOff
              : inputReadyProductReducer.weight,
            weightOff: inputReadyProductReducer.weightOff,
            zdvlLineNumId: inputReadyProductReducer.zdvlLineNumId,
            // eslint-disable-next-line max-len
            plantOperationAttribsInheritDtos: inputReadyProductReducer.plantOperationAttribsInheritDtos
              ? inputReadyProductReducer.plantOperationAttribsInheritDtos
              : [],
            quantity: useFactWeight
              ? inputReadyProductReducer.quantityOff
              : inputReadyProductReducer.quantity,
            quantityOff: inputReadyProductReducer.quantityOff,
            unitOfMeasure: inputReadyProductReducer.unitOfMeasure,
            unitShort: inputReadyProductReducer.productUnit
          });
          onModalHiding();
        }
      });
    }
  }

  const onConfirmationDeleteClick = () => {
    deleteReadyProductsMultiple({
      operationNumIds: dataSource.selectList.map((el) => el.operationNumId),
      plantId
    });
    closeHeaderButton();
  };

  const onSaveOperationClick = () => {
    saveOperation();
  };

  const onClickCb = useCallback(() => {
    setVisibleModalInput(false);
    closeHeaderButton();
  }, [closeHeaderButton]);

  const onClickCancelBtn = useCallback(() => {
    onModalHiding();
  }, [onModalHiding]);

  useEffect(() => {
    if (correctionReadyProductsReducer.okRequestModal) {
      onModalHiding();
    }
  }, [correctionReadyProductsReducer.okRequestModal, onModalHiding]);

  const onClickUpdate = useCallback(() => {
    getReadyProducts({ plantId });
  }, [getReadyProducts, plantId]);

  return (
    <>
      <HeaderButtonMVP headButtVisibol={headButtVisible}>
        {correctionReadyProductsReducer.readyProducts.length > 0 && (
          <>
            <Button text={formatMessage('textButton').remove}
                    type={'danger'}
                    stylingMode={'contained'}
                    onClick={() => setDeleteConfirmationVisible(true)}
                    className={styles.danger}
            />
            <Button text={formatMessage('textButton').inputData}
                    type={'default'}
                    stylingMode={'contained'}
                    onClick={onClickInputData}
            />
            { plantId === '8200' && correctionReadyProductsReducer.readyProducts
              && correctionReadyProductsReducer.readyProducts
                .filter((item) => item.operationNumId !== selectedKey).length ? (
                  <Button text={(correctionReadyProductsReducer.readyProducts
                    .filter((item) => item.operationNumId !== selectedKey))[0].mountingDate === null
                    ? formatMessage('textButton').toMount
                    : formatMessage('textButton').toUnmount}
                          type={'default'}
                          stylingMode={'contained'}
                          onClick={onClickToMount}
              />
              ) : ''}
          </>
        )}
      </HeaderButtonMVP>
      <DataGridMVP
        setStateStoringName={'dataGridGetReadyProducts'}
        keyExpr="operationNumId"
        onSelectionChanged={onSelectionChanged}
        visibleButtonDateRangePicker={false}
        visibleSummary={false}
        visibleGroupPanel={false}
        className={styles.mainTable}
        visibleInfoIcon={false}
        tText={formatMessage('textPeriod')}
        dataSource={(plantId !== 8200
          ? (correctionReadyProductsReducer.readyProducts.filter((item) => (item.key !== 'mountingDate')))
          : correctionReadyProductsReducer.readyProducts)}
        loadingData={
          correctionReadyProductsReducer.loading
          || inputReadyProductReducer.loading
        }
        isDataLoading={
          correctionReadyProductsReducer.loading
          || inputReadyProductReducer.loading
        }
        filterDataGrid
        onClickUpdate={onClickUpdate}
        visibleButtonUpdate
      >
        {columnDataGrid.map((item) => (
          <Column
            dataField={item.dataField}
            caption={item.caption}
            visible={!item.notVisible}
            allowSearch
            allowFiltering
            cellRender={item.cellRender}
            key={item.dataField}
            dataType={item.dataType}
            cssClass={item.cssClass}
            width={item.width ? item.width : undefined}
          />
        ))}
      </DataGridMVP>
      <PopupMVP
        visible={visibleModalInput}
        onHiding={onModalHiding}
        title={'Корректировка ГП'}
        width={'90%'}
        height={'auto'}
      >
        <div className="formData">
          <InputModalReadyProducts
            plantId={plantId}
            onClickCb={onClickCb}
            setValidateInstance={setValidateInstance}
            setOnModalSaveClick={setOnModalSaveClick}
            useFactWeight={useFactWeight}
          />
          <div className="formButton">
            <Button
              type="default"
              stylingMode="contained"
              onClick={() => {
                setCorrectionSemiModalVisible(true);
              }}
              width={260}
              text={formatMessage('textButton').addReady}
            />
            <Button
              type="default"
              stylingMode="contained"
              onClick={async () => {
                await onModalSaveClick();
                await sleep(1000);
                await onSaveOperationClick();
                await sleep(1000);
                await updateSemiProduct();
              }}
              width={260}
              text={formatMessage('textButton').save}
            />
            <Button
              type="default"
              stylingMode="contained"
              onClick={onClickCancelBtn}
              width={260}
              text={formatMessage('textButton').cancel}
            />
          </div>
        </div>
      </PopupMVP>
      <PopupMVP
        visible={deleteConfirmationVisible}
        onHiding={onModalHiding}
        title={'Подтверждение'}
      >
        <div className="formData">
          <h3>
            {`${
              formatMessage('production').deleteConfirmation
                .deleteConfirmationP1
            } ${dataSource.selectList[0] && dataSource.selectList[0].qcId}
           ${
             formatMessage('production').deleteConfirmation.deleteConfirmationP2
           } ${dataSource.selectList[0] && dataSource.selectList.sum('weightOff')} 
           ${dataSource.selectList[0] && dataSource.selectList[0].unitShort}`}
          </h3>
          <div className="formButton">
            <Button
              type="default"
              stylingMode="contained"
              onClick={onConfirmationDeleteClick}
              width={260}
            >
              <LoadIndicator className="indicator" visible={correctionReadyProductsReducer.loadingModal} />
              <span>{formatMessage('textButton').remove}</span>
            </Button>
            <Button
              type="default"
              stylingMode="contained"
              onClick={onClickCancelBtn}
              width={260}
              text={formatMessage('textButton').cancel}
            />
          </div>
        </div>
      </PopupMVP>
      <AddSemiForCorrection
        plantId={plantId}
        visible={correctionSemiModalVisible}
        setVisible={setCorrectionSemiModalVisible}
      />
    </>
  );
};

export default React.memo(CorrectionReadyProductsTable);
